// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2egAp","errors":"Errors_errors__3GyZE"};